import {
    createSlice
} from '@reduxjs/toolkit';

// cat. define
import {
    CONFIG_SYSTEM_DEFAULTS,
} from 'config/configs/system';

import {
    APP_CONFIG,
} from '../configs/settings/app.config';
import {
    PAGE_VIEW_CONFIG,
    PAGE_FORM_CONFIG,
} from '../configs/settings/page.config';

import {parseSystemConfig} from '../utils/settingsParser';

const initialState = {
    APP_CONFIG: APP_CONFIG,
    PAGE_VIEW_CONFIG: PAGE_VIEW_CONFIG,
    PAGE_FORM_CONFIG: PAGE_FORM_CONFIG,
    SYSTEM: CONFIG_SYSTEM_DEFAULTS,
};

const settingsReducer = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        /**
         * app 설정 정보 초기화
         * @param {Object} action.payload - app 설정 정보 객체
         */
        initSettingsApp: (state, action) => {
            return {
                ...state,
                ...action.payload
            };
        },

        /**
         * app 설정 정보 업데이트
         * @param {Object} action.payload - 업데이트할 app 설정 정보
         */
        /*updateSettingsApp: (state, action) => {
            return {
                ...state,
                ...action.payload
            };
        },
*/
        /**
         * page 설정 정보 초기화
         * @param {Object} action.payload - page 설정 정보 객체
         */
        initSettingsPage: (state, action) => {
            return {
                ...state,
                ...action.payload
            };
        },

        /**
         * page 설정 정보 업데이트
         * @param {Object} action.payload - 업데이트할 page 설정 정보
         */
        /*updateSettingsPage: (state, action) => {
            return {
                ...state,
                ...action.payload
            };
        },*/

        /**
         * 시스템 설정 초기화
         * 백엔드에서 받은 설정 목록을 파싱하여 state에 반영
         *
         * @param {Object} state - 현재 상태
         * @param {Object} action - action 객체
         * @param {Array} action.payload - 시스템 설정 배열 [{configKey, configValue}, ...]
         */
        initSettingsSystem: (state, action) => {
            const systemConfigList = action.payload || [];
            const parsedSystemConfig = parseSystemConfig(systemConfigList, CONFIG_SYSTEM_DEFAULTS);

            state.SYSTEM = {
                ...state.SYSTEM,
                ...parsedSystemConfig
            };
        },

        /**
         * 시스템 설정 업데이트
         * initSettings와 동일한 로직
         *
         * @param {Object} state - 현재 상태
         * @param {Object} action - action 객체
         * @param {Array} action.payload - 시스템 설정 배열
         */
        updateSettings: (state, action) => {
            const configList = action.payload || [];
            const parsedSystemConfig = parseSystemConfig(configList, CONFIG_SYSTEM_DEFAULTS);

            state.SYSTEM = {
                ...state.SYSTEM,
                ...parsedSystemConfig
            };
        },
    },
});

export const {
    initSettingsApp,
    initSettingsPage,
    initSettingsSystem,
    updateSettings,
} = settingsReducer.actions;

export default settingsReducer.reducer;
